import {memoize} from 'lodash-decorators/memoize';

// @ts-ignore
@memoize()
export function getAgeAtDate(birthDate: string | Date, visitDate: string | Date = new Date()) {
  // https://stackoverflow.com/questions/4060004/calculate-age-given-the-birth-date-in-the-format-yyyymmdd/7091965#7091965

  birthDate = typeof birthDate === 'string' ? new Date(birthDate) : birthDate;
  visitDate = typeof visitDate === 'string' ? new Date(visitDate) : visitDate;
  let age = visitDate.getFullYear() - birthDate.getFullYear();
  const m = visitDate.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && visitDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}
